import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { Logo } from "@/components/common/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) return navigate("/login", { replace: true });
    api
      .post("/auth/google", { session_id: sessionId })
      .then(({ data }) => {
        loginWithToken(data.token, data.user);
        navigate("/consultation/new", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#07131A] contaha-grid">
      <div className="rounded-xl bg-[#0E1A21] px-4 py-3 border border-[#223139]"><Logo /></div>
      <div className="h-7 w-7 rounded-full border-2 border-[#00A85A] border-t-transparent animate-spin" />
      <p className="text-sm text-[#8B9698]">Signing you in...</p>
    </div>
  );
}
